export const SET_TOKEN = '[USER] SET_TOKEN';
export const SET_ID = '[USER] SET_ID';
export const SET_IS_AUTHENTICATED = '[USER] SET_IS_AUTHENTICATED';
export const USER_SIGNING_IN = '[USER] USER_SIGNING_IN';
export const USER_SIGNING_UP = '[USER] USER_SIGNING_UP';
export const REQUEST_SIGN_OUT = '[USER] REQUEST_SIGN_OUT';
export const SET_SUSCRIPTIONS = '[USER] SET_SUSCRIPTIONS';
